const options = {
  5: "bg-stone-200/5",
  10: "bg-stone-200/10",
  25: "bg-stone-200/25",
  50: "bg-stone-200/50",
  75: "bg-stone-200/75",
  90: "bg-stone-200/90",
  100: "bg-stone-200",
};

const from = {
  5: "from-stone-200/5",
  10: "from-stone-200/10",
  25: "from-stone-200/25",
  50: "from-stone-200/50",
  75: "from-stone-200/75",
  90: "from-stone-200/90",
  100: "from-stone-200",
};

export default function getBackgroundStone200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
